import { render, staticRenderFns } from "./CrearSocio.vue?vue&type=template&id=391babbc&"
import script from "./CrearSocio.vue?vue&type=script&lang=js&"
export * from "./CrearSocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports